import Client from 'shopify-buy';

const shopClient = Client.buildClient({
  domain: 'julianafutter.myshopify.com',
  storefrontAccessToken: 'a71074e1a11ce0ff6e71acb100f5e537',
});

export default shopClient;
